module.exports = __webpack_public_path__ + "f195a867bddfaf902336603f4e522232.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-cross.svg
// module id = CLzQ
// module chunks = 5